/* eslint-disable */
export default {
  save: 'Speichern',
} as const;

// @key: @#@"save"@#@ @source: @#@"Save"@#@
